import React, { FC } from 'react'

import { FeedStoryProps } from './FeedStory.props'

import { AutoStory, PeakStory } from '..'
import { ZoneFeedStory } from '../../../../components/Story/containers/ZoneFeedStory'

const FeedStory: FC<FeedStoryProps> = ({
  story,
  dataTestPrefix,
  chartData
}) => (
  <>
    {story.argument_type === 'radio' || story.argument_type === 'stream' ? (
      <AutoStory story={story} />
    ) : story.argument_type === 'peak' ? (
      <PeakStory story={story} chartData={chartData} />
    ) : (
      <ZoneFeedStory
        story={story}
        dataTestPrefix={dataTestPrefix}
      />
    )}
  </>
)

export default FeedStory
